'use strict';

import { showErrorModal } from 'Root/modal';
import { isValidIBAN } from 'Components/form/ibanValidator';
import { onCompanyChange } from './checkout/helpers/companySearchHelpers';
import { toggleButtonState } from 'Root/util/util';
import VZSpinner from 'Components/VZSpinner';
import { initChooserInvite } from 'Components/chooserInvite';
import 'Components/form/VZInputField';
import 'Components/form/VZDatePicker';
import 'Components/navigation';

import 'bootstrap/js/src/collapse.js';

import 'Components/chat';
import 'Components/form/VZFormFeedback';
import 'Components/form/VZIdentification';
import 'Components/form/VZInputField';
import 'Components/form/VZDateField';
import 'Components/form/VZSelect';
import 'Components/form/VZComment';
import 'Components/form/VZCopy';
import 'Components/scrolling';
import 'Components/VZCard';
import 'Root/checkout/VZCompanySearch';
import 'Root/checkout/VZBillingAddress';
import 'Root/checkout/kvkmodal';
import 'Root/product/components/VZDeleteGroup';
import 'Components/drawers/VZOpenDrawer';
import 'Components/drawers/VZDrawer';
import './service-worker';
import 'Root/checkout/VZDeliveryPlanner';

import 'Components/prompt';
import 'Components/modals/VZModal';
import { Datepicker } from 'vanillajs-datepicker';

/**
 * @constant {Object} SELECTORS - Used selectors
 * @property {string} SEARCH_FIELD - Search field for KVK lookup
 * @property {string} SEARCH_SUBMIT_BUTTON - Submit button for KVK lookup
 * @property {string} RESULTS_DROPDOWN - Results dropdown for KVK population
 */
const SELECTORS = {
    FORM: '.js-checkout-form',
    FORM_SUBMIT: '.js-checkout-submit',
    IBAN: '.js-iban',
    SEARCH_FIELD: '.js-company-search',
    RESULTS_DROPDOWN: '.js-kvk-companies',
    COMPANY_SEARCH_RESULT: '.js-company-result',
    ACCEPT_TERMS_CHECKBOX: '.js-accept-terms-checkbox',
    ACCEPT_DIRECT_DEBIT_PAYMENT_CHECKBOX: '.js-accept-direct-debit-payment-checkbox',
    PLACE_ORDER_BTN: '.js-checkout-login-and-place',
    DOB_FIELD: '.js-dob',
    ACCEPT_PAYMENTS_CHECKBOX: '.js-payment-checkbox',
    PLACE_ORDER_LOGGED_IN_BTN: '.js-place-order',
    CONTACT_PERSON_FIELD: '.js-contact-person-field',
    BILLING_ADDRESS_ADDRESS1: '.js-billing-address-address1',
    BILLING_ADDRESS_CITY: '.js-billing-address-city',
    FILL_ADDITIONAL_FIELDS_CHECKBOX: '[name="fillAdditionalFields"]',
    ADDITIONAL_FIELDS_TOGGLE: '.js-additional-fields-toggle',
    ADDITIONAL_FIELDS_CONTAINER: '.additional-fields'
};

const dropdown = document.querySelector(SELECTORS.RESULTS_DROPDOWN);
const searchField = document.querySelector(SELECTORS.SEARCH_FIELD);
const iBAN = document.querySelector(SELECTORS.IBAN);
const companySearchResultContainer = document.querySelector(SELECTORS.COMPANY_SEARCH_RESULT);
const acceptTermsCheckbox = document.querySelector(SELECTORS.ACCEPT_TERMS_CHECKBOX);
const acceptDirectdDebitPaymentCheckbox = document.querySelector(SELECTORS.ACCEPT_DIRECT_DEBIT_PAYMENT_CHECKBOX);
const acceptPaymentsCheckbox = document.querySelector(SELECTORS.ACCEPT_PAYMENTS_CHECKBOX);
const placeOrderBtn = document.querySelector(SELECTORS.PLACE_ORDER_BTN);
const placeOrderBtnLoggedIn = document.querySelector(SELECTORS.PLACE_ORDER_LOGGED_IN_BTN);
const dobField = document.querySelector(SELECTORS.DOB_FIELD);

/**
 * @function showServerError
 * @param {HTMLFormElement} form - The submitted form
 */
function showServerError(form) {
    const { title, body, cta } = JSON.parse(form.getAttribute('data-general-error'));
    showErrorModal(title, body, cta);
}

/**
 * @private onSubmit
 * @param {ChangeEvent} evt - submit event
 */
function onSubmit(evt) {
    evt.preventDefault();
    const form = evt.currentTarget;
    const spinner = document.querySelector('vz-spinner') || new VZSpinner();

    // checkValidity always returns true on disabled and readonly fields. Therefore a manual check ends to be applied.
    const address1 = document.querySelector(SELECTORS.BILLING_ADDRESS_ADDRESS1);
    const city = document.querySelector(SELECTORS.BILLING_ADDRESS_CITY);
    const addressIsValid = !(address1 && city && (address1.value.length === 0 || city.value.length === 0));

    if (!form.checkValidity() || !addressIsValid) {
        const feedback = document.querySelector('vz-form-feedback') || document.createElement('vz-form-feedback');
        feedback.show(form);
        document.getElementById('app').children[0].insertAdjacentElement('afterend', feedback);
        return;
    }

    // allow empty string as a value, since the field is optional
    if (iBAN && iBAN.value !== '' && !isValidIBAN(iBAN.value.replace(/\s/g, ''))) {
        iBAN.validate(
            {
                target: iBAN
            },
            iBAN.getAttribute('data-pattern-error')
        );
        return;
    }
    const formData = new FormData(form);
    [...document.querySelectorAll('input[name$="|wishDate"].datepicker-input:not(hidden)')].forEach((input) => {
        const strDate = Datepicker.parseDate(input.value, 'dd-MM-yyyy', 'nl');
        const modifiedDate = Datepicker.formatDate(strDate, 'dd-mm-yyyy', 'nl');
        formData.append(`${input.name}DisplayValue`, input.value);
        if (formData.get(input.name)) {
            formData.set(input.name, modifiedDate);
        }

        const selectOtherPerson = document.querySelector(`[name="contact-person-${input.name.split('|')[0]}"]`);
        if (selectOtherPerson) {
            formData.append(`${input.name.split('|')[0]}|otherPerson`, selectOtherPerson.checked);
        }
    });

    spinner.start();
    fetch(form.action, {
        method: 'POST',
        body: formData
    })
        .then((res) => res.json())
        .then((res) => {
            if (res.success) {
                window.location.href = res.redirectUrl;
            } else {
                showServerError(form);
            }
        })
        .catch(() => {
            showServerError(form);
        })
        .finally(spinner.stop);
}

/**
 * @private handleFormSubmitBtnState
 */
function handleFormSubmitBtnState() {
    toggleButtonState(this.querySelector(SELECTORS.FORM_SUBMIT), this.checkValidity());
}

/**
 * @private placeOrderForLoggedInCustomer
 * @param {Event} e - click event
 */
function placeOrderForLoggedInCustomer(e) {
    e.preventDefault();
    const spinner = document.querySelector('vz-spinner') || new VZSpinner();
    spinner.start();
    const orderFormData = new FormData();
    orderFormData.append(window.csrf.tokenName, window.csrf.token);
    const { title, body, cta } = JSON.parse(document.querySelector(SELECTORS.FORM).getAttribute('data-general-error'));
    fetch(e.target.href, {
        method: 'POST',
        body: orderFormData
    })
        .then((res) => res.json())
        .then((res) => {
            if (res.success) {
                window.location.href = res.redirectUrl;
            } else if (res.serverErrors && res.serverErrors.length > 0) {
                // Redirect if redirectURL is available
                if (res.redirectUrl) {
                    window.location.href = res.redirectUrl;
                } else {
                    showErrorModal(title, res.serverErrors[0], cta);
                }
            }
        })
        .catch((res) => {
            if (!res?.responseJSON) {
                showErrorModal(title, body, cta);
            }
            if (res?.responseJSON) {
                showErrorModal(title, body, cta);
            }
        })
        .finally(spinner.stop);
}

/**
 * Tracks the selection of a company during the checkout process.
 *
 * @function trackCompanySelection
 * @returns {void}
 *
 * @description
 * Retrieves checkout data from the DOM, updates it with step-related information,
 * and pushes it to the data layer for tracking purposes.
 */
function trackCompanySelection() {
    const gtmCheckoutData = document.getElementById('gtmCheckoutFullEvent');
    let ecommerceObject;
    if (gtmCheckoutData) {
        ecommerceObject = JSON.parse(gtmCheckoutData.value);
    }
    if (ecommerceObject && ecommerceObject.ecommerce && ecommerceObject.ecommerce.checkout) {
        ecommerceObject.ecommerce.checkout.step_name = 'Bedrijfsgegevens';
        ecommerceObject.ecommerce.checkout.step_nr = 5;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(ecommerceObject);
        // eslint-disable-next-line no-underscore-dangle
        if (window._ddm) {
            // eslint-disable-next-line no-underscore-dangle
            window._ddm.trigger('ecommerce.checkout', {
                data: ecommerceObject.ecommerce.checkout
            });
        }
    }
}

/**
 * @private bindFormValidation
 */
function bindFormValidation() {
    const form = document.querySelector(SELECTORS.FORM);
    const button = form.querySelector(SELECTORS.FORM_SUBMIT);
    placeOrderBtnLoggedIn?.addEventListener('click', placeOrderForLoggedInCustomer);

    if (!form) return;

    form.addEventListener('submit', onSubmit);

    // Run validation checks to enable or disable submit button on all checkout steps.
    if (form.querySelector(SELECTORS.FORM_SUBMIT)) {
        // Check validity on any form element change to enable or disable submit button.
        form.addEventListener('change', handleFormSubmitBtnState);
    }

    // Only run on checkout step 1.
    if (searchField && companySearchResultContainer) {
        // Check validity when company search result is shown to enable or disable submit button. Event fired from VZCompanySearch.js.
        companySearchResultContainer.addEventListener('shown:companySearchResult', (event) => {
            handleFormSubmitBtnState.bind(form)();
            if (!event.detail?.isEditing) {
                trackCompanySelection();
            }
        });
    }

    if (dobField) {
        dobField.addEventListener('blur', handleFormSubmitBtnState.bind(form));
    }

    initChooserInvite();

    // Check validity on page load
    if (form.checkValidity()) {
        if (button) toggleButtonState(button, true);
        if (placeOrderBtn) toggleButtonState(placeOrderBtn, true);
    }

    // Updates the submit button state based on checkbox states
    if (acceptTermsCheckbox && placeOrderBtn) {
        const updateButtonState = () => {
            const isTermsChecked = acceptTermsCheckbox.checked;
            const isDirectDebitChecked = !acceptDirectdDebitPaymentCheckbox || acceptDirectdDebitPaymentCheckbox.checked;
            placeOrderBtn.classList.toggle('disabled', !(isTermsChecked && isDirectDebitChecked));
        };

        acceptTermsCheckbox.addEventListener('change', updateButtonState);
        acceptDirectdDebitPaymentCheckbox?.addEventListener('change', updateButtonState);
        updateButtonState();
    }

    // Place an order after SSO redirect
    const isSsoRedirect = document.querySelector('[name="isSsoRedirect"]')?.value === 'true';
    if (isSsoRedirect && placeOrderBtnLoggedIn) {
        placeOrderBtnLoggedIn.dispatchEvent(new CustomEvent('click'));
    }
}

/**
 * @function insertIbanMoreInfoDrawerBtn
 * @description Adds a more info drawer btn by replacing an anchor in the iBan label with a vz-open-drawer element
 */
function insertIbanMoreInfoDrawerBtn() {
    const iBanContainer = iBAN.closest('.container');
    const btnToReplace = iBanContainer.querySelector('.js-iban-more-info-btn');
    if (!btnToReplace) return;

    const { textContent: btnText } = btnToReplace;
    const iBanMoreInfoDrawerBtn = iBanContainer.querySelector('vz-open-drawer');
    const iBanMoreInfoDrawerBtnAnchor = iBanMoreInfoDrawerBtn.querySelector('button');
    iBanMoreInfoDrawerBtnAnchor.textContent = btnText;

    // Replace the entire element with the class .js-iban-more-info-btn with the btn to open the drawer
    const iBanLabel = iBanContainer.querySelector('.js-checkout-iban-label');
    iBanLabel.replaceChild(iBanMoreInfoDrawerBtn, btnToReplace);

    iBanMoreInfoDrawerBtn.classList.remove('d-none');
    iBanMoreInfoDrawerBtn.classList.add('d-inline-block');
}

/**
 * Manages the state of the additional fields section.
 */
function initializeAdditionalFieldsToggle() {
    const checkbox = document.querySelector(SELECTORS.FILL_ADDITIONAL_FIELDS_CHECKBOX);
    if (!checkbox) return;
    const toggleLabel = document.querySelector(SELECTORS.ADDITIONAL_FIELDS_TOGGLE);

    const fieldsToToggle = document.querySelectorAll(
        `${SELECTORS.ADDITIONAL_FIELDS_CONTAINER} input, ${SELECTORS.ADDITIONAL_FIELDS_CONTAINER} select, ${SELECTORS.ADDITIONAL_FIELDS_CONTAINER} textarea`
    );

    const toggleFieldsState = () => {
        if (toggleLabel) {
            const isExpanded = checkbox.checked;

            toggleLabel.setAttribute('aria-expanded', checkbox.checked ? 'true' : 'false');
            toggleLabel.setAttribute('aria-hidden', isExpanded ? 'true' : 'false');
            toggleLabel.tabIndex = isExpanded ? -1 : 0;
            toggleLabel.hidden = isExpanded;
        }

        fieldsToToggle.forEach((field) => {
            field.disabled = !checkbox.checked;
        });
    };

    if (toggleLabel) {
        toggleLabel.addEventListener('keydown', (event) => {
            if (event.key !== ' ' && event.key !== 'Enter') return;

            event.preventDefault();
            checkbox.checked = !checkbox.checked;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    checkbox.addEventListener('change', toggleFieldsState);
    toggleFieldsState(); // Set initial state
}

// Init information page
if (searchField && dropdown) {
    dropdown.addEventListener('change', onCompanyChange);
}

if (iBAN) {
    const handleIBANBlur = () => {
        const form = document.querySelector(SELECTORS.FORM);

        // allow empty string as a value, since the field is optional
        if (iBAN.value !== '') {
            if (!isValidIBAN(iBAN.value.replace(/\s/g, ''))) {
                iBAN.validate(
                    {
                        target: iBAN
                    },
                    iBAN.getAttribute('data-pattern-error')
                );
            }
            if (acceptPaymentsCheckbox) {
                acceptPaymentsCheckbox.required = true;
            }
        } else if (acceptPaymentsCheckbox) {
            acceptPaymentsCheckbox.required = false;
            [acceptPaymentsCheckbox, iBAN].forEach((element) => {
                const errorMessage = element.parentElement.querySelector('.error-msg');
                if (errorMessage) {
                    errorMessage.remove();
                }
            });
        }

        // Check form's validity and update submit button's state
        handleFormSubmitBtnState.call(form);
    };

    iBAN.addEventListener('blur', handleIBANBlur);
    iBAN.addEventListener('input', handleIBANBlur);

    // update acceptPaymentsCheckbox when editing details
    if (iBAN.value !== '') {
        iBAN.dispatchEvent(new Event('blur'));
    }

    // Replace anchor in iBan label with vz-open-drawer btn
    insertIbanMoreInfoDrawerBtn();
}

window.addEventListener('load', () => {
    bindFormValidation();
    initializeAdditionalFieldsToggle();
});
